import { Dispatch } from 'redux'

import { AppFilter } from '../../../redux/filter-ts/filterModels'
import { getConceptDayCommentsApiCall } from '../../entities/Comment/CommentService'
import { isFetchCollectionResultSuccessful } from '../../entities/FetchResult'
import { getCheckedFormOptionsValue } from '../../helpers/types/formOption'
import { setConceptDayComments, setError, setIsLoading } from './ConceptDayCommentsReducer'

export const getConceptDayComments = (
    startDate?: Date,
    endDate?: Date,
    filters?: AppFilter,
) => async (dispatch: Dispatch): Promise<void> => {
    dispatch(setIsLoading(true))

    const departmentIds = getCheckedFormOptionsValue(filters?.departmentOptions || [])

    try {
        const result = await getConceptDayCommentsApiCall(startDate, endDate, departmentIds)

        if (! isFetchCollectionResultSuccessful(result)) {
            dispatch(setError(result.error))
            return
        }

        dispatch(setConceptDayComments(result.data))
    } catch (error) {
        console.error('[getConceptDayComments]', error)
    } finally {
        dispatch(setIsLoading(false))
    }
}
